function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ANIMATION_TIMEOUT } from "@config/constants";
import React, { Component } from "react";
var Video = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Video, Component);
    var _super = _create_super(Video);
    function Video(props) {
        _class_call_check(this, Video);
        var _this;
        _this = _super.call(this, props);
        _this.video = null;
        _this.hls = null;
        _this.state = {
            isActiveButtonOverlay: false,
            shouldShowVolumeOffIcon: false,
            shouldShowVolumeUpIcon: false,
            shouldShowVolumeDownIcon: false,
            shouldShowPlayIcon: false,
            shouldShowPauseIcon: false
        };
        return _this;
    }
    _create_class(Video, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this = this;
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, videoAdditionalProps = _this_props.videoAdditionalProps;
                if (videoPlayer.video.volume !== prevProps.videoPlayer.video.volume && typeof prevProps.videoPlayer.video.volume !== "undefined") {
                    if (videoAdditionalProps.isVolumeChangedFromKeyboard) {
                        videoPlayer.video.volume > prevProps.videoPlayer.video.volume ? this.setState({
                            shouldShowVolumeUpIcon: true
                        }) : this.setState({
                            shouldShowVolumeDownIcon: true
                        });
                    }
                    if (videoAdditionalProps.isSoundToggledFromKeyboard && videoPlayer.video.volume === 0) {
                        this.setState({
                            shouldShowVolumeOffIcon: true
                        });
                    }
                }
                if (videoPlayer.video.paused !== prevProps.videoPlayer.video.paused && !videoAdditionalProps.isVideoChanged) {
                    videoPlayer.video.paused ? this.setState({
                        shouldShowPauseIcon: true
                    }) : this.setState({
                        shouldShowPlayIcon: true
                    });
                }
                if (this.state.shouldShowPlayIcon || this.state.shouldShowPauseIcon || videoAdditionalProps.isForwardClicked || videoAdditionalProps.isBackwardClicked || this.state.shouldShowVolumeOffIcon || this.state.shouldShowVolumeDownIcon || this.state.shouldShowVolumeUpIcon) {
                    if (!this.state.isActiveButtonOverlay) {
                        this.setState({
                            isActiveButtonOverlay: true
                        });
                    }
                    setTimeout(function() {
                        _this.setState({
                            isActiveButtonOverlay: false,
                            shouldShowVolumeOffIcon: false,
                            shouldShowVolumeDownIcon: false,
                            shouldShowVolumeUpIcon: false,
                            shouldShowPlayIcon: false,
                            shouldShowPauseIcon: false
                        });
                    }, ANIMATION_TIMEOUT);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, actions = _this_props.actions, videoAdditionalProps = _this_props.videoAdditionalProps, videoPlayer = _this_props.videoPlayer, castSession = _this_props.castSession, canSupportNativeHls = _this_props.canSupportNativeHls;
                var buttonStateClass = "";
                var isForwardClicked = videoAdditionalProps.isForwardClicked;
                var isBackwardClicked = videoAdditionalProps.isBackwardClicked;
                if (isForwardClicked) {
                    buttonStateClass = " icon-forward-15";
                } else if (isBackwardClicked) {
                    buttonStateClass = " icon-replay-15";
                } else if (this.state.shouldShowVolumeOffIcon) {
                    buttonStateClass = " icon-volume-off";
                } else if (this.state.shouldShowVolumeDownIcon) {
                    buttonStateClass = " icon-volume-mute";
                } else if (this.state.shouldShowVolumeUpIcon) {
                    buttonStateClass = " icon-volume-up";
                } else if (this.state.shouldShowPlayIcon) {
                    buttonStateClass = " icon-play";
                } else if (this.state.shouldShowPauseIcon) {
                    buttonStateClass = " icon-pause";
                }
                return /*#__PURE__*/ _jsxs("div", {
                    className: "video-chromecast-overlay",
                    children: [
                        castSession && /*#__PURE__*/ _jsxs("div", {
                            className: "chromecast-message-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-cast"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "chromecast-label",
                                    children: "Chromecasting..."
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("video", {
                            ref: this.props.customRef,
                            autoPlay: true,
                            playsInline: true,
                            crossOrigin: "anonymous",
                            controls: canSupportNativeHls,
                            className: "video".concat(castSession ? " chromecast-hidden" : ""),
                            onClick: actions.togglePlay,
                            onEnded: actions.ended,
                            tabIndex: videoPlayer.video.source ? "0" : "-1",
                            onTimeUpdate: actions.timeUpdate,
                            onProgress: actions.progress
                        }),
                        /*#__PURE__*/ _jsx("canvas", {
                            id: "dvb-canvas",
                            width: "1024",
                            height: "576"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "button-overlay".concat(this.state.isActiveButtonOverlay ? " active" : ""),
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "icon control".concat(buttonStateClass)
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Video;
}(Component);
export default Video;
